import * as React from 'react';

const TextDefaultChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="text-default-chunky_svg__eds-icon--text-default-chunky_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            id="text-default-chunky_svg__eds-icon--text-default-chunky_path"
            d="M8 19.5H6v-4H4v-2h6v2H8v4zm-1-15h13v4h-2v-2h-4v13h-2v-13H8v2H6v-4h1z"
        />
    </svg>
);

TextDefaultChunkySvg.displayName = 'TextDefaultChunkySvg';
export default TextDefaultChunkySvg;
